import React, { useState } from 'react';
import NewUserInfo from '../../Main/NewUserInfo';
import { CircularProgress, Dialog, Grid, makeStyles, Avatar } from '@material-ui/core';
import styles from '../../Main/main.styles';
import { capitalize, isEmpty } from 'lodash';
import EmergencyButton from '../Components/EmergencyButton';
import useStore from '../../Store/Store';
import AddIcon from '@mui/icons-material/Add';
import './CareRecipients.css';
import GirlImage from '../../images/girl.png';
import BoyImage from '../../images/boy.png';
import { useNavigate } from 'react-router-dom';
import { useMutation, useQuery } from 'react-query';
import { changeRelationStatus, getCareRecipients } from '../../utils/api';
import { careUserType, CARE_CIRCLE_RELATION_STATUS, ICON_BUTTON_TYPE } from '../../constants';
import DeleteIcon from '@mui/icons-material/Delete';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import AddCaregivers from '../Dashboard/components/AddCaregivers';
import IconButton from '../../components/IconButton';

const useStyles = makeStyles(styles);

const CareRecipients = () => {
  const history = useNavigate();
  const classes = useStyles();
  const user = useStore((state) => state.user);
  const width = useStore((state) => state.screenWidth);
  const [addCaregiverModal, setAddCaregiverModal] = useState(false);

  const {
    data: recipients,
    isLoading,
    refetch,
  } = useQuery(['getCareRecipients'], () => getCareRecipients({ userId: user?._id || user?.id, filter: 'all' }), {
    retry: false,
    cacheTime: 0,
  });

  const changeStatus = useMutation(changeRelationStatus, {
    onSuccess: (data) => {
      refetch();
    },
    onError: (error) => {
      console.log('error =====> ', error);
    },
  });

  const handleClickDetail = (userId) => {
    history(`/care-recipients/${userId}/recipient-details`);
  };

  const handleChangeStatus = (id, status) => {
    changeStatus.mutate({ userId: user?._id, relationId: id, status });
  };

  return (
    <>
      <NewUserInfo />
      <div className="flex-column-a" style={{ left: width > 850 ? '15%' : '0%' }}>
        <Grid container justifyContent="space-between" alignItems="center">
          <h1>Care recipients</h1>
          <div className="invite-caregiver-button" onClick={() => setAddCaregiverModal(true)}>
            <AddIcon />
            Invite Care recipients
          </div>
        </Grid>
        {isLoading && (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '40vh',
              width: '100%',
            }}
          >
            <CircularProgress style={{ color: '#26786a' }} size={100} />
          </div>
        )}
        {!isLoading &&
          (isEmpty(recipients?.data) ? (
            <Grid container justifyContent="center" className="no-caregiver-div">
              <h3>No care recipients found!</h3>
            </Grid>
          ) : (
            recipients?.data.map((item, idx) => (
              <Grid
                container
                justifyContent="space-between"
                alignItems="center"
                className="caregivers-div"
                key={idx}
                style={{ marginTop: '20px' }}
              >
                <Grid sm={12} lg={6} md={6} xs={12} container>
                  <Avatar
                    src={
                      !isEmpty(item?.careRecipientId?.userInfo?.imageUrl)
                        ? item?.careRecipientId?.userInfo?.imageUrl
                        : item?.careRecipientId?.userInfo?.gender === 'female'
                          ? GirlImage
                          : BoyImage
                    }
                    alt={item?.careRecipientId?.userInfo?.firstName}
                    style={{
                      height: '100px',
                      width: '100px',
                    }}
                  />
                  <div style={{ marginLeft: '20px' }}>
                    <h2>
                      {item?.careRecipientId?.userInfo?.firstName} {item?.careRecipientId?.userInfo?.lastName || ''}
                    </h2>
                    <span className="cg-phone-email">{capitalize(item?.careRecipientId?.userInfo?.gender || '')}</span>
                    <span className="cg-phone-email">
                      {item?.careRecipientId?.userInfo?.age && `${item?.careRecipientId?.userInfo?.age} y.o.`}
                    </span>
                  </div>
                </Grid>
                {item?.status === CARE_CIRCLE_RELATION_STATUS.pending &&
                item?.addedBy === careUserType.careRecipient ? (
                  <Grid sm={12} lg={6} md={6} xs={12} style={{ display: 'flex', justifyContent: 'end' }}>
                    <Grid>
                      <CheckCircleIcon
                        style={{ color: 'black' }}
                        className="delete-icon"
                        onClick={() => handleChangeStatus(item?._id, CARE_CIRCLE_RELATION_STATUS.active)}
                      />
                    </Grid>
                    <Grid>
                      <DeleteIcon
                        style={{ color: 'black', marginLeft: '20px' }}
                        className="delete-icon"
                        onClick={() => handleChangeStatus(item?._id, CARE_CIRCLE_RELATION_STATUS.cancelled)}
                      />
                    </Grid>
                  </Grid>
                ) : item?.status === CARE_CIRCLE_RELATION_STATUS.pending && item?.addedBy === careUserType.cargiver ? (
                  <Grid sm={12} lg={6} md={6} xs={12} style={{ display: 'flex', justifyContent: 'end' }}>
                    <Grid className="health-box">
                      <small>Invited</small>
                    </Grid>
                  </Grid>
                ) : (
                  <Grid sm={12} lg={6} md={6} xs={12} style={{ display: 'flex', justifyContent: 'end' }}>
                    <Grid className="health-box">
                      <small>Weight</small>
                      <span className="bold">{item?.careRecipientId?.userInfo?.weight || ''}</span>
                    </Grid>
                    <Grid className="health-box">
                      <small>Height</small>
                      <span className="bold">{item?.careRecipientId?.userInfo?.height || ''}</span>
                    </Grid>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                      <IconButton
                        type={ICON_BUTTON_TYPE.forward}
                        onClick={() => handleClickDetail(item?.careRecipientId?._id)}
                      />
                    </div>
                  </Grid>
                )}
              </Grid>
            ))
          ))}
      </div>
      <Dialog className={classes.modal} open={addCaregiverModal} maxWidth={false}>
        <AddCaregivers user={user} refresh={refetch} closeModal={() => setAddCaregiverModal(false)} recipient={true} />
      </Dialog>
      <EmergencyButton />
    </>
  );
};

export default CareRecipients;
